import Header from "../Header";
import Footer from "../Footer";
import Breadcrumbs from "../Breadcrumbs";
import BannerImg from "../assets/Images/Banner.png";

import BottomLogoImg from "../assets/Images/bottom-logo.png";
import LineImg from "../assets/Images/line.png";
import HkrgLogoImg from "../assets/Images/hkrg_logo.jpg";
import HKASLogoImg from "../assets/Images/HKAS logo.jpg";
import HKBIALogoImg from "../assets/Images/HKBIA logo.jpg";
import CoDecoLogoImg from "../assets/Images/CoDeco Logo.jpg";
import GraphicImg from "../assets/Images/graphic.jpg";
import PdfImg from "../assets/Images/pdf.png";
import DownloadIconImg from "../assets/Images/downloadicon.png";
import "./HKRenovationGuidelinePage.scss";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

const HKRenovationGuideline = () => {
  const { t } = useTranslation();
  return (
    <>
      <Header />
      <div className="banner">
        <img src={BannerImg} alt="" />
        <div className="banner_title res">
          <h1 className="banner-main-title">{t("hk_renovation_guideline")}</h1>
          <p className="banner-subtitle">{t("renovation_p0")}</p>
        </div>
      </div>
      <Breadcrumbs>
        <Link>{t("home")} &gt; </Link>
        <span>{t("renovation_p0")}</span>
      </Breadcrumbs>
      <main className="hk-renovation-main-container">
        <section className="hk-renovation-intro-section">
          <img src={HkrgLogoImg} alt="" className="hk-renovation-logo" />
          <h1 className="hk-renovation-version">{t("renovation_version")}</h1>
          <h2 className="hk-renovation-updated">{t("renovation_updated")}</h2>
          <p className="hk-renovation-intro-text">{t("renovation_p1")}</p>
        </section>
        <section className="hk-renovation-logos-section">
          <img src={HKASLogoImg} alt="" />
          <img src={HKBIALogoImg} alt="" />
          <img src={CoDecoLogoImg} alt="" />
        </section>
        <img className="hk-renovation-graphic-img" src={GraphicImg} alt="" />
        <section className="hk-renovation-content-section">
          <h3>{t("renovation_p2")}</h3>
          <h3>{t("renovation_p3")}</h3>
          <div className="spans">
            <span>{t("renovation_p4")}</span>
            <span>{t("renovation_p5")}</span>
            <span>{t("renovation_p6")}</span>
          </div>
          <div className="paragraphs">
            <p>
              <span>1</span>
              {t("renovation_p7")}
            </p>
            <p>
              <span>2</span>
              {t("renovation_p8")}
            </p>
            <p>
              <span>3</span>
              {t("renovation_p9")}
            </p>
          </div>
        </section>
        <section className="hk-renovation-download-section">
          {/* <h3>下載</h3> */}
          {/* <div className="download-pdf"> */}
          <img src={PdfImg} alt="" />
          <span>{t("renovation_p10")}</span>
          <a
            href="https://www.hkarbsoc.org.hk/public/2020_04_29_HKRG-pdf.pdf"
            className="hk-renovation-download-link"
          >
            <img
              src={DownloadIconImg}
              alt=""
              className="hk-renovation-download-icon"
            />
          </a>
          {/* </div> */}
        </section>
        <section className="hk-renovation-qa-section">
          <h3>{t("renovation_p11")}</h3>
          <p>
            <span>Q1</span>
            {t("renovation_p12")}
          </p>
          <p>{t("renovation_p13")}</p>
          <p>{t("renovation_p14")}</p>
          <p>
            <span>Q2</span>
            {t("renovation_p15")}
          </p>
          <p>{t("renovation_p16")}</p>
          <p>{t("renovation_p17")}</p>
          <p>
            <span>Q3</span>
            {t("renovation_p18")}
          </p>
          <p>{t("renovation_p19")}</p>
          <p>{t("renovation_p20")}</p>
          <p>{t("renovation_p21")}</p>
          <p>
            <span>Q4</span>
            {t("renovation_p22")}
          </p>
          <p>{t("renovation_p23")}</p>
        </section>
        {/* <div className="line-pic">
          <img src={LineImg} alt="" />
        </div> */}
      </main>
      <div className="temporary">
        <img src={BottomLogoImg} alt="" />
      </div>

      <Footer />
    </>
  );
};

export default HKRenovationGuideline;
